import { isDateValid } from "@lyfegen-platform/utils";
import { EMPTY_VALUE_PLACEHOLDER } from "../models/common/data";

export const localeDateTime = (date: Date | string | undefined | null, placeholder?: string) => {
	if (!date) {
		return placeholder || EMPTY_VALUE_PLACEHOLDER;
	}

	if (typeof date === "string") {
		date = new Date(date.trim());
		if (!isDateValid(date)) {
			return placeholder || EMPTY_VALUE_PLACEHOLDER;
		}
	}

	return date.toLocaleString(window.navigator.languages[0]);
};
